import React, { useState } from "react";
import { CONSENT_PATH } from "../../legal/operator";

function ShopCartCheckoutConsent({ isVisible = true, onAccept }) {
  const [checked, setChecked] = useState(false);

  if (!isVisible) return null;

  return (
    <div className="mx-2 mb-2 w-full rounded-md border border-green-200 bg-green-50 px-3 py-3 text-center dark:border-green-900/40 dark:bg-green-950/30">
      <div className="text-sm font-semibold text-black dark:text-black">
        Чтобы оформить заказ, нужно дать согласие на обработку персональных данных.
      </div>

      <label className="mt-3 flex w-full items-start justify-center gap-3 text-left text-sm text-gray-800 dark:text-gray-200">
        <input
          type="checkbox"
          className="mt-0.5 h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-600"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
        />
        <span>
          Я даю согласие на{" "}
          <a
            className="link"
            href={CONSENT_PATH}
            target="_blank"
            rel="noreferrer"
          >
            обработку персональных данных
          </a>
        </span>
      </label>

      <button
        type="button"
        className="shop-action-button mx-2 mt-3 w-full"
        disabled={!checked}
        onClick={() => {
          if (!checked) return;
          onAccept?.();
        }}
      >
        Принять
      </button>
    </div>
  );
}

export default ShopCartCheckoutConsent;
